import { number, struct } from 'io-ts/Decoder';

import { ScalePath } from '../../../../whole-house/scale';

export const Request = struct({
	scale: number,
	path: ScalePath,
});
